define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var $rahmen = $(".weiterlesenRahmen");
        var $rahmenContent = $rahmen.find(".weiterlesenRahmen_content");
        var $rahmenButton = $rahmen.find(".weiterlesenRahmen_button");
        var rahmenButtonVisibleContentSelector = "weiterlesenRahmen_button--is-content-open";
        $rahmenButton.on("click", function (event) {
            var $button = $(event.target);
            $rahmenContent.slideToggle(Configuration_1.configuration.slideDownAnimationTimeInMs);
            if ($button.hasClass(rahmenButtonVisibleContentSelector)) {
                $button.text("Mehr lesen");
                $button.removeClass(rahmenButtonVisibleContentSelector);
            }
            else {
                $button.text("Details ausblenden");
                $button.addClass(rahmenButtonVisibleContentSelector);
            }
            event.preventDefault();
        });
    });
});
